module.exports = __webpack_public_path__ + "static/dct-clean-83e4b07260e832ee974ae262fbabad11.png";